import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import stockReducer from '../features/Stock/stockSlice';
import orderReducer from '../features/order/orderSlice';
export const store = configureStore({
	reducer: {
		auth: authReducer,
		stock: stockReducer,
		order: orderReducer,
	},
});
